import React, { useEffect } from 'react';

import Layout from '../../containers/Layout';
import ImageTitle, { Icons } from '../../components/ImageTitle';
import { Container, Content } from './styles';
import { useCheckoutGtm } from '../../hooks/gtm/checkout/useCheckoutGtm';

const OrderCanceled: React.FC<any> = (props: any) => {
  const order = props?.location?.state?.order;
  const { sendDataToGtm } = useCheckoutGtm();

  useEffect(() => {
    if (order)
      sendDataToGtm(order, {
        type: 'checkout',
        name: '/pagamento/infos-pagamento-error',
      });
  }, [order]);

  return (
    <Layout dark>
      <Container>
        <ImageTitle
          data-cy='cancel-order'
          icon={Icons.orderCanceled}
          text="O pedido foi cancelado com sucesso."
          primary
        />

        <Content data-cy="info-message">
          Caso você queira fazer outro pedido ou tenha alguma dúvida, por favor
          entre em contato com o vendedor.
        </Content>
      </Container>
    </Layout>
  );
};

export default OrderCanceled;
